(function() {
  var Controller,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty,
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  Controller = App.loadClass('core::Angular/Controller');

  exports.SelectSurveysController = (function(superClass) {
    extend(SelectSurveysController, superClass);

    function SelectSurveysController(scope, transitions, repo, modal) {
      this.scope = scope;
      this.transitions = transitions;
      this.repo = repo;
      this.modal = modal;
      this.isSurveyResultSelected = bind(this.isSurveyResultSelected, this);
      this.allSurveyResultsAreSelected = bind(this.allSurveyResultsAreSelected, this);
      this.checkUniqueFieldLimit = bind(this.checkUniqueFieldLimit, this);
      this.toggleSurveyResult = bind(this.toggleSurveyResult, this);
      this.selectAllSurveyResults = bind(this.selectAllSurveyResults, this);
      this.showSurveyFields = bind(this.showSurveyFields, this);
      this.hasDuplicateFields = bind(this.hasDuplicateFields, this);
      this.canContinue = bind(this.canContinue, this);
      this.next = bind(this.next, this);
      this.previous = bind(this.previous, this);
      this.sanityCheck = bind(this.sanityCheck, this);
      this.loadSurveyResults = bind(this.loadSurveyResults, this);
      SelectSurveysController.__super__.constructor.call(this, this.scope, this.transitions);
      this.scope.step.title = 'Select Surveys';
      this.scope.step.previous = this.previous;
      this.scope.step.next = this.next;
      this.scope.step.canContinue = this.canContinue;
      this.scope.placeholder = 'Loading survey results...';
      this.scope.survey_results = [];
      this.scope.showSurveyFields = this.showSurveyFields;
      this.scope.selectAllSurveyResults = this.selectAllSurveyResults;
      this.scope.toggleSurveyResult = this.toggleSurveyResult;
      this.scope.isSurveyResultSelected = this.isSurveyResultSelected;
      this.scope.numPlans = (function(_this) {
        return function(sr) {
          return Object.keys(sr.planned_fields).length;
        };
      })(this);
      this.input_changed = false;
      this.scope.$watchCollection('selected.survey_results', (function(_this) {
        return function(val, old_val) {
          if (val !== old_val) {
            return _this.input_changed = true;
          }
        };
      })(this));
      this.loadSurveyResults();
    }

    SelectSurveysController.prototype.loadSurveyResults = function() {
      return this.repo.getSurveyResults(this.scope.selected.years, this.scope.selected.spps).then((function(_this) {
        return function(result) {
          var ref, ref1, ref2;
          if (((ref = result.data) != null ? (ref1 = ref.status) != null ? ref1.type : void 0 : void 0) !== 'success') {
            if (((ref2 = result.data) != null ? ref2.status : void 0) != null) {
              _this.scope.$parent.setAlert(result.data.status);
            } else {
              _this.scope.$parent.setAlert({
                type: 'error',
                msg: 'Failed to load survey results'
              });
            }
            return;
          }
          _this.scope.survey_results = result.data.data.survey_results;
          if (_this.scope.survey_results.length === 0) {
            _this.scope.placeholder = 'No survey results found';
          } else {
            if (_this.scope.selected.survey_results.length === 0) {
              _this.selectAllSurveyResults();
            }
          }
          return _this.sanityCheck();
        };
      })(this), (function(_this) {
        return function() {
          return _this.scope.$parent.setAlert({
            type: 'error',
            msg: 'Failed to load survey results'
          });
        };
      })(this));
    };

    SelectSurveysController.prototype.sanityCheck = function() {
      var j, ref, results, survey_result;
      ref = this.scope.selected.survey_results;
      results = [];
      for (j = ref.length - 1; j >= 0; j += -1) {
        survey_result = ref[j];
        if (_.findIndex(this.scope.survey_results, {
          id: survey_result.id
        }) === -1) {
          results.push(this.toggleSurveyResult(survey_result));
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    SelectSurveysController.prototype.previous = function() {
      this.scope.$parent.clearAlert();
      return this.scope.goToStep('select_year_and_crop');
    };

    SelectSurveysController.prototype.next = function() {
      this.scope.$parent.clearAlert();
      if (this.input_changed) {
        this.scope.selected.duplicate_fields = [];
      }
      if (this.hasDuplicateFields()) {
        return this.scope.goToStep('duplicate_fields');
      } else {
        return this.repo.launchPsr(this.scope.selected, this.scope.step);
      }
    };

    SelectSurveysController.prototype.canContinue = function() {
      return this.scope.selected.survey_results.length > 0;
    };

    SelectSurveysController.prototype.hasDuplicateFields = function() {
      var id, j, layer_id, len, name, ref, ref1, sr, unique_field_ids;
      unique_field_ids = [];
      ref = this.scope.selected.survey_results;
      for (j = 0, len = ref.length; j < len; j++) {
        sr = ref[j];
        if (unique_field_ids[name = sr.year] == null) {
          unique_field_ids[name] = [];
        }
        ref1 = sr.planned_fields;
        for (id in ref1) {
          layer_id = ref1[id];
          if (indexOf.call(unique_field_ids[sr.year], id) >= 0) {
            return true;
          } else {
            unique_field_ids[sr.year].push(id);
          }
        }
      }
      return false;
    };

    SelectSurveysController.prototype.showSurveyFields = function(survey_result) {
      var modal_instance;
      return modal_instance = this.modal.open({
        windowClass: 'small_dialog',
        templateUrl: 'backend/grower/placement/survey-fields-dialog',
        controller: 'Placement.Controllers.SurveyFieldsDialogController',
        scope: this.scope,
        resolve: {
          'survey_result': function() {
            return survey_result;
          }
        }
      });
    };

    SelectSurveysController.prototype.selectAllSurveyResults = function() {
      var j, len, ref, selectable_survey_results, survey_result;
      if (this.scope.survey_results.length === 0) {
        return;
      }
      selectable_survey_results = [];
      ref = this.scope.survey_results;
      for (j = 0, len = ref.length; j < len; j++) {
        survey_result = ref[j];
        if (this.checkUniqueFieldLimit(survey_result, selectable_survey_results) === true) {
          selectable_survey_results.push(survey_result);
        }
      }
      if (this.allSurveyResultsAreSelected(selectable_survey_results)) {
        return this.scope.selected.survey_results = [];
      } else {
        this.scope.selected.survey_results = selectable_survey_results;
        if (this.scope.selected.survey_results.length < this.scope.survey_results.length) {
          return this.scope.$parent.setAlert({
            type: 'error',
            msg: 'Due to export size limitations, the Placement Report cannot include more than 50 fields at a time. Since you have created planting plans for more than 50 fields, not all of your surveys can be selected at this time. (Hint: You can run multiple batches if needed.)'
          });
        }
      }
    };

    SelectSurveysController.prototype.toggleSurveyResult = function(survey_result) {
      var i, num;
      i = _.findIndex(this.scope.selected.survey_results, {
        id: survey_result.id
      });
      if (i === -1) {
        num = this.checkUniqueFieldLimit(survey_result);
        if (num === true) {
          return this.scope.selected.survey_results.push(survey_result);
        } else {
          return this.scope.$parent.setAlert({
            type: 'error',
            msg: "Due to export size limitations, the Placement Report cannot include more than 50 fields at a time. Since you have already selected " + num + " fields that have planting plans, this survey cannot be selected at this time."
          }, [], 10000);
        }
      } else {
        return this.scope.selected.survey_results.splice(i, 1);
      }
    };

    SelectSurveysController.prototype.checkUniqueFieldLimit = function(survey_result, selected_survey_results) {
      var id, j, layer_id, len, num_new_fields, num_selected_fields, ref, ref1, sr, unique_field_ids;
      if (selected_survey_results == null) {
        selected_survey_results = null;
      }
      unique_field_ids = [];
      if (selected_survey_results == null) {
        selected_survey_results = this.scope.selected.survey_results;
      }
      for (j = 0, len = selected_survey_results.length; j < len; j++) {
        sr = selected_survey_results[j];
        ref = sr.planned_fields;
        for (id in ref) {
          layer_id = ref[id];
          if (indexOf.call(unique_field_ids, id) < 0) {
            unique_field_ids.push(id);
          }
        }
      }
      num_selected_fields = unique_field_ids.length;
      num_new_fields = 0;
      ref1 = survey_result.planned_fields;
      for (id in ref1) {
        layer_id = ref1[id];
        if (indexOf.call(unique_field_ids, id) < 0) {
          num_new_fields += 1;
          if (num_selected_fields + num_new_fields > 50) {
            return num_selected_fields;
          }
        }
      }
      return true;
    };

    SelectSurveysController.prototype.allSurveyResultsAreSelected = function(survey_results) {
      var j, len, survey_result;
      for (j = 0, len = survey_results.length; j < len; j++) {
        survey_result = survey_results[j];
        if (!this.isSurveyResultSelected(survey_result)) {
          return false;
        }
      }
      return true;
    };

    SelectSurveysController.prototype.isSurveyResultSelected = function(survey_result) {
      return _.findIndex(this.scope.selected.survey_results, {
        id: survey_result.id
      }) > -1;
    };

    return SelectSurveysController;

  })(Controller);

}).call(this);
